import { useDispatch } from 'react-redux'
import { resetDynamicFilters } from '@store/redux/actions/filterActions'
import Translations from '@helpers/translations'
import { FilterOption } from 'types/filters'
import { ReactComponent as CloseIcon } from '@svgs/close.svg'
import styles from './styles.module.scss'
import {
  BUILD,
  CHEST_SIZE,
  CUT,
  LEG,
  LENGTH,
  SHORTSLEG,
  SIZE,
  SWIMSHORTSLEG,
  WAIST
} from '@consts/index'

type Category = {
  title: string
  key: string[]
}

type FiltersProps = {
  onClearFilters: (filters: FilterOption[]) => void
  filters: FilterOption[]
}
function Filters({ filters, onClearFilters }: FiltersProps) {
  if (!filters.length) return null
  return (
    <div>
      <ul>
        {filters.map(activeFilter => (
          <li key={activeFilter.type} className="grid">
            <p className={styles.filterResultsKey}>
              {Translations.localise(`collection.filters.${activeFilter.type}`)}
              :
            </p>
            <p className={styles.filterResultsValue}>{activeFilter.value}</p>
          </li>
        ))}
      </ul>
      <button type="button" onClick={() => onClearFilters(filters)}>
        <CloseIcon
          className={styles.CloseIcon}
          aria-label="close icon"
          width="10"
          height="10"
        />
      </button>
    </div>
  )
}

const CATEGORY_LIST = [
  {
    title: `${Translations.localise(
      'collection.filters.trousers'
    )} & ${Translations.localise('collection.filters.shorts')}`,
    key: [
      WAIST.toLowerCase(),
      BUILD.toLowerCase(),
      LEG.toLowerCase(),
      SHORTSLEG.toLowerCase(),
      SWIMSHORTSLEG.toLowerCase()
    ]
  },
  {
    title: Translations.localise('collection.filters.tops'),
    key: [
      SIZE.toLowerCase(),
      CHEST_SIZE.toLowerCase(),
      CUT.toLowerCase(),
      LENGTH.toLowerCase()
    ]
  }
]

type FilterResultProps = {
  totalResults: number
  selectedFilterOptions: FilterOption[]
}

function FilterResult({
  totalResults,
  selectedFilterOptions
}: FilterResultProps) {
  const dispatch = useDispatch()
  const handleClearFilters = (filters: FilterOption[]) => {
    dispatch(resetDynamicFilters(filters))
  }

  return (
    <div className={styles.multiFilters__results}>
      <div className={styles.multiFilters__results__searchTitle}>
        {Translations.localise(`collection.filters.showing-results`).replace(
          '%t',
          `${totalResults}`
        )}
      </div>
      {selectedFilterOptions.length > 0 && (
        <div className={styles.multiFilters__results__list}>
          {CATEGORY_LIST.map((filter, index) => {
            const activeFilters = selectedFilterOptions.filter(filterOption => {
              const listKeys = filter.key.map(key => key.toLowerCase())
              return !listKeys.includes(filterOption.type.toLowerCase())
            })
            return (
              <Filters
                onClearFilters={handleClearFilters}
                filters={activeFilters}
                key={`${filter.title}-${index}`}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

export default FilterResult
